import { axios } from '@/plugins/axios.js'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchCreditNotes(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/credit_notes', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCreditNote(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/credit_notes/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createCreditNote(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/credit_notes', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateCreditNote(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`api/v1/credit_notes/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    voidCreditNote(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/credit_notes/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  }
}